var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Main-Content",attrs:{"id":"AccountScheduledReportsList"}},[_c('Page',{attrs:{"title":_vm.$t('Scheduled Reports'),"primaryAction":{
      label: _vm.$t('scheduledReports.scheduleNewReport'),
      onAction: function () { return _vm.scheduleNewReport(); },
      disabled: _vm.saving
    },"fullWidth":""}},[_c('Layout',[_c('LayoutSection',[_c('Card',[_c('Filters',{attrs:{"filters":[
              {
                key: 'status',
                label: this.$t('Status'),
                type: 'select',
                placeholder: this.$t('Choose a status'),
                multiple: true,
                options: [
                  {label: this.$t('Enabled'), value: 'enabled' },
                  {label: this.$t('Disabled'), value: 'disabled'}
                ]
              }
            ],"query":_vm.query,"applied-filters":_vm.appliedFilters},on:{"update:query":[function($event){_vm.query=$event},_vm.setQuery],"update:applied-filters":_vm.setAppliedFilters}}),_c('DataTable',{attrs:{"columns":[
              {
                key: 'name',
                label: _vm.$t('Name')
              },
              {
                key: 'period',
                label: _vm.$t('scheduledReports.frequency')
              },
              {
                key: 'language',
                label: _vm.$t('Language')
              },
              {
                key: 'status',
                label: _vm.$t('Status')
              },
              {
                key: 'scheduleStartDate',
                label: _vm.$t('Start Date'),
                format: 'dateLong'
              }
            ],"rows":_vm.formattedReports,"row-actions":function (row) { return _vm.getRowActions(row); },"loading":_vm.loading,"pagination":{
              offset: _vm.offset,
              limit: _vm.limit,
              total: _vm.formattedReports.length,
              updateOffset: _vm.updateOffset,
              updateLimit: _vm.updateLimit
            }},scopedSlots:_vm._u([{key:"col:name",fn:function(ref){
            var row = ref.row;
return [_c('PageLink',{attrs:{"href":_vm.getReportUrl(row.id)}},[_vm._v(_vm._s(row.name))])]}},{key:"col:language",fn:function(ref){
            var row = ref.row;
return [_vm._v("\n              "+_vm._s(_vm.getLanguage(row.language))+"\n            ")]}},{key:"col:status",fn:function(ref){
            var row = ref.row;
return [(row.status === 'enabled')?_c('Badge',{attrs:{"status":"success"}},[_vm._v(_vm._s(_vm.$t('Enabled')))]):_c('Badge',{attrs:{"status":"warning"}},[_vm._v(_vm._s(_vm.$t('Disabled')))])]}}])})],1)],1)],1)],1),_c('Modal',{attrs:{"title":_vm.$t('scheduledReports.runReportForDates'),"primaryAction":{
      label: _vm.$t('Start'),
      onAction: _vm.runForDates,
      disabled: _vm.saving || _vm.runForDatesError
    },"visible":_vm.showRunForDates},on:{"close":_vm.closeRunForDates}},[(_vm.runForDatesObj)?_c('FormLayout',[_c('DatePicker',{attrs:{"label":_vm.$t('scheduledReports.startDateInclusive')},model:{value:(_vm.runForDatesObj.startDate),callback:function ($$v) {_vm.$set(_vm.runForDatesObj, "startDate", $$v)},expression:"runForDatesObj.startDate"}}),_c('DatePicker',{attrs:{"label":_vm.$t('scheduledReports.endDateInclusive')},model:{value:(_vm.runForDatesObj.endDate),callback:function ($$v) {_vm.$set(_vm.runForDatesObj, "endDate", $$v)},expression:"runForDatesObj.endDate"}}),(_vm.runForDatesError)?_c('InlineError',[_vm._v(_vm._s(_vm.runForDatesError))]):_c('div',[_vm._v(_vm._s(_vm.$t('scheduledReports.runForXDays', {value: _vm.dateRange })))])],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }